import React from "react";
import { SubAccounts_table } from "./SubAccounts_table";

export const SubAccounts = () => {
  return <SubAccounts_table />;
};
